import useJsonFlag from "./useJsonFlag";
import { USER_PROFILE_FLAG } from "queries/users/userFlagsModel";
import { useMemo } from "react";

type UserProfileData = {
  age: string;
  interests: string[];
  referrals: string[];
  motivation?: string[]; // Optional - legacy field, no longer collected in onboarding
  role?: "student" | "teacher";
  whatBringsYou?: string[]; // Optional since teachers skip the whatBringsYou question
};

const DEFAULT_USER_PROFILE_DATA: UserProfileData = {
  age: "",
  interests: [],
  referrals: [],
  motivation: [],
  role: "student",
  whatBringsYou: []
};

const useUserProfile = () => {
  const { getFlagData: getUserProfileData, saveFlagData: saveUserProfileData } = useJsonFlag<UserProfileData>(
    USER_PROFILE_FLAG,
    DEFAULT_USER_PROFILE_DATA
  );

  const userProfileData = useMemo(() => getUserProfileData(), [getUserProfileData]);

  return useMemo(
    () => ({
      saveUserProfileData,
      userProfileData
    }),
    [saveUserProfileData, userProfileData]
  );
};

export default useUserProfile;
